import { convertAbsoluteUrlToRelativeUrl } from '../../app/router-utils';
import { setSearchParamInnerImpl } from './set-search-param-inner-impl';
import type { UrlSearchParamsTypes } from './url-search-params';
import type UrlSearchParamKey from './url-search-params';

export const setSearchParamOnUrl = <SearchKey extends UrlSearchParamKey>(
  url: URL,
  searchParamKey: SearchKey,
  value: UrlSearchParamsTypes[SearchKey],
) => {
  const searchParams = new URLSearchParams(url.search);
  setSearchParamInnerImpl(searchParams, searchParamKey, value);
  // eslint-disable-next-line no-param-reassign
  url.search = searchParams.toString();
};

export const getRelativeStringWithSearchParam = <
  SearchKey extends UrlSearchParamKey,
>(
    relativeRoute: string,
    searchParamKey: SearchKey,
    value: UrlSearchParamsTypes[SearchKey],
  ) => {
  const destinationUrl = new URL(relativeRoute, window.location.origin);
  setSearchParamOnUrl(destinationUrl, searchParamKey, value);

  return convertAbsoluteUrlToRelativeUrl(destinationUrl.toString());
};
